import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-green-600 via-emerald-600 to-teal-600 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 via-green-400 to-teal-400 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-leaf-line text-white text-lg"></i>
                </div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-br from-pink-400 to-rose-400 rounded-full flex items-center justify-center">
                  <i className="ri-heart-fill text-white text-xs"></i>
                </div>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white leading-tight" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの植物
                </span>
                <span className="text-xs text-green-100 leading-tight">
                  ～モモちゃん畑～
                </span>
              </div>
            </div>
            <p className="text-white/90 mb-4">
              植物愛好家のための総合情報サイト。花と植物の美しい世界をお届けします。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-white/80 hover:text-white cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-white/80 hover:text-white cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-white/80 hover:text-white cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">植物情報</h3>
            <ul className="space-y-2">
              <li><Link to="/plants" className="text-white/90 hover:text-white cursor-pointer">植物図鑑</Link></li>
              <li><Link to="/flower-language" className="text-white/90 hover:text-white cursor-pointer">花言葉</Link></li>
              <li><Link to="/prefecture-flowers" className="text-white/90 hover:text-white cursor-pointer">県の花</Link></li>
              <li><Link to="/knowledge" className="text-white/90 hover:text-white cursor-pointer">花の特徴</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-4">サービス</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  運営者について
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <a href="/contact" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-white/90">
            © {currentYear} みんなの植物～モモちゃん畑～. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="text-white hover:text-green-100 ml-1 cursor-pointer">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
